/**
 * IconUnlinked — broken-link glyph for a guitar FX pedal that's registered
 * (bound + ported, per DEC-152) but whose bridge isn't currently connected.
 * Shared by PresetChange and SnapshotChange rather than duplicated per file.
 *
 * Hand-drawn stroke style per DEC-141 (Header.tsx's nav/status icons): 20x20
 * viewBox, `currentColor` stroke so it inherits whatever color the caller's
 * fault text is already painted in (`--sk-fault`), rather than hardcoding one.
 */
export function IconUnlinked() {
  return (
    <svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true" class="pedal-unlinked-icon">
      <path
        d="M7 12.5 4.6 14.9a2.6 2.6 0 0 1-3.7-3.7L3.3 8.8"
        fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
      />
      <path
        d="M13 7.5 15.4 5.1a2.6 2.6 0 0 0-3.7-3.7L9.3 3.8"
        fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
      />
      <path d="M3 3 17 17" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" />
    </svg>
  );
}
